import dev from './development/en.json';
const merge = require('deepmerge');

export default async ({ $axios, $config }) => {
    return await $axios.$get(`${$config.baseURL}/api/en/translate`).then((res) => {
        return merge(dev, res);
    });
};
